import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import { reviewBudgetStyles } from "@insite/content-library/Widgets/Budget/ReviewBudget";
import { css } from "styled-components";

reviewBudgetStyles.wrapper = {
    css: css`
        display: inline-block;
        margin: 0 30px 15px 0;
        > div[class^="FormFieldStyle"] {
            select[data-test-selector^="reviewBudgetUserSelector"] {
                padding: 0 30px 0 10px;
            }
        }
    `,
};
configureBudgetStyles.gridItems = {
    css: css`
        overflow: auto;
    `,
};
assignBudgetsStyles.assignBudgetInstructionsGridItem = {
    width: 12,
    css: css`
        padding: 15px;
    `,
};
assignBudgetsStyles.tableGridItem = {
    width: [12, 12, 12, 12, 6],
    css: css`
        overflow: auto;
        padding: 15px;
    `,
};
